
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class WPOpacity extends Vue {
  @Prop({ default: false })
  private opacity?: boolean
}
